export const criteria = {
  title: 'Kryteria',
  subtitle: 'Zdefiniuj możliwe przyszłe konfiguracje.',
  add: 'Dodaj kryterium',
  createTitle: 'Nowe kryterium',
  editTitle: 'Edytuj kryterium',
  createValueTitle: 'Nowa wartość',
  editValueTitle: 'Edytuj wartość',
  hasDependency: 'Ma zależność',
  dependencyTitle: 'Zależność',
  dependencyDescription: 'Ustawienia zależności będą dostępne tutaj.',
  dependencyCriterion: 'Kategoria (typ)',
  dependencyValue: 'Wartość',
  addedDependencies: 'Dodane zależności',
  newDependencyDescription:
    'Wybierz kryterium i jego wartość, aby dodać nową zależność.',
  addDependency: 'Dodaj',
  undoDependency: 'Cofnij',
  removeDependency: 'Usuń zależność {name}',
  emptyDependencyTitle: 'Brak dostępnych kryteriów',
  emptyDependencyDescription:
    'Wcześniejsze kryteria nie mają wolnych wartości, od których można uzależnić. Najpierw dodaj do nich wartości.',
  name: 'Nazwa',
  codeLabel: 'Kod',
  root: 'Kryterium główne',
  addValue: 'Dodaj wartość',
  emptyValueTitle: 'Pusta wartość',
  emptyValuesTitle: 'Brak wartości kryteriów',
  emptyValuesDescription: 'Dodaj kryteria, aby zdefiniować ich wartości.',
  emptyCriterionValuesTitle: 'Brak wartości',
  emptyCriterionValuesDescription:
    'Dodaj wartość, aby umożliwić wybór tego kryterium.',
  emptyTitle: 'Brak kryteriów',
  emptyDescription:
    'Dodaj kryterium, aby zdefiniować możliwe przyszłe konfiguracje.',
  placeholderTitle: 'Puste kryterium',
  placeholderDescription: 'Szczegóły kryterium zostaną skonfigurowane tutaj.',
  dragHandle: 'Zmień kolejność kryterium {number}',
  dragAloneGroupHint:
    'Chwyć z wciśniętym {key}, aby przesunąć tylko to kryterium',
  dragAloneHint:
    'Przytrzymaj {key}, aby przesunąć tylko to kryterium i przyklejone pod nim',
  dragCarriedByDependency: 'Przesunie się razem z przeciąganym kryterium',
  dragHeldByDependency: 'Zostaje, zależy od mijanego kryterium',
  dragTopLocked:
    'Pierwsze kryterium jest w grupie z przeciąganym i nie może zostać zastąpione',
  required: 'Wymagane',
  active: 'Aktywne',
  code: 'Brak kodu',
  createdSuccess: 'Kryterium zostało utworzone',
  updatedSuccess: 'Kryterium zostało zaktualizowane',
  updatedIndexSuccess: 'Kolejność kryteriów została zaktualizowana',
  valueCreatedSuccess: 'Wartość została utworzona',
  valueUpdatedSuccess: 'Wartość została zaktualizowana',
  valueUpdatedIndexSuccess: 'Kolejność wartości została zaktualizowana',
  deletedSuccess: 'Kryterium zostało usunięte',
  valueDeletedSuccess: 'Wartość została usunięta',
  deleteTitle: 'Usunąć kryterium „{name}”?',
  deleteDescription:
    'Jego wartości również zostaną usunięte. Wersje robocze flow zachowają je z oznaczeniem usunięcia.',
  deleteValueTitle: 'Usunąć wartość „{name}”?',
  deleteValueDescription:
    'Wersje robocze flow zachowają ją z oznaczeniem usunięcia.',
  deleteArchivesFlows:
    'Opublikowane flow, które z tego korzystają: {count}. Zostaną zarchiwizowane.',
  tabs: {
    criteria: 'Kryteria',
    criteriaDescription:
      'Zdefiniuj kryteria, które określają dostępne konfiguracje.',
    values: 'Wartości kryteriów',
    valuesDescription:
      'Zarządzaj dostępnymi wartościami dla każdego kryterium.',
  },
} as const
